<template>
  <a class="play-button">
    <span class="icon" aria-hidden="true">
      <play-icon />
    </span>
    <slot />
  </a>
</template>

<script>
import PlayIcon from '../icons/PlayIcon';

export default {
  components: {
    PlayIcon,
  },
};
</script>

<style lang="scss" scoped>
@import '../../constants/style';

.play-button {
  background: #eb5757;
  border-radius: 9999px;
  color: #fff;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  line-height: 32px;
  height: 56px;
  width: 300px;
  padding: 12px 48px;
  text-align: center;
  transition: background 0.3s ease-out;

  &:hover {
    background: #ce3f3f;
  }

  > .icon {
    display: block;
    height: 20px;
    width: 20px;
    margin-right: 8px;

    > svg {
      vertical-align: top;
    }
  }
}

@media #{$mq-sp} {
  .play-button {
    font-size: 14px;
  }
}
</style>
